import { z } from "zod";

export const subscriptionFormSchema = z.object({
  planId: z.string().min(1, "יש לבחור תוכנית מנוי"),
});

export type SubscriptionFormValues = z.infer<typeof subscriptionFormSchema>;
